import * as types from '../../constants/ActionTypes.js'

const initObjectManagementState = {
    objectgroups: [],
    selectedobjectitem: {},
    selectedobjectgroup: null,
    messagebartext: ""
}

export const objectManagementReducer = function init(state = initObjectManagementState, action) {
    switch (action.type) {
        case types.RECEIVE_OBJECTGROUPLIST:
            const objectGroups = action.json;

            return Object.assign({}, state, {
                objectgroups: objectGroups,
                selectedobjectgroup: objectGroups.length > 0 ? objectGroups[0].ObjectGroupId : null
            })
        case types.SET_CURRENT_OBJECTGROUP:
            return Object.assign({}, state, {
                selectedobjectgroup: action.id
            })
        case types.OBJECTMANAGEMENT_SET_RECEIPT_NUMBER:
            return Object.assign({}, state, {
                objectgroups: action.objectgrouparray
            })
        case types.SET_SELECTED_OBJECTITEM:
            return Object.assign({}, state, {
                selectedobjectitem: action.objectitem
            });
        case types.SET_MESSAGEBAR_TEXT:
            return Object.assign({}, state, {
                messagebartext: action.messagebartext
            });
        case types.CLEAR_STATE:
            return Object.assign({}, initObjectManagementState, {});
        case types.EMPTY_RECEIPT:
        return Object.assign({}, state, {
            selectedobjectitem: {}
        });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/objectmanagement/reducers/objectmanagement.js